import type {PermissionsRecordType} from '../permissions';

export const accountingPermissions = {
  readCashRegisterDocument: {
    actionId: 'READ',
    resourceId: 'CASH_REGISTER_DOCUMENT',
    scopes: ['CASH_REGISTER_DOCUMENT.BRANCH'],
  },
  createCashRegisterDocument: {
    actionId: 'CREATE',
    resourceId: 'CASH_REGISTER_DOCUMENT',
    scopes: ['CASH_REGISTER_DOCUMENT.BRANCH'],
  },
  cancelCashRegisterDocument: {
    actionId: 'CANCEL',
    resourceId: 'CASH_REGISTER_DOCUMENT',
    scopes: ['CASH_REGISTER_DOCUMENT.BRANCH'],
  },
  readInvoice: {
    actionId: 'READ',
    resourceId: 'INVOICE',
    scopes: ['INVOICE.BRANCH'],
  },
  createInvoice: {
    actionId: 'CREATE',
    resourceId: 'INVOICE',
    scopes: [],
  },
  sendInvoice: {
    actionId: 'SEND',
    resourceId: 'INVOICE',
    scopes: [],
  },
  cancelInvoice: {
    actionId: 'CANCEL',
    resourceId: 'INVOICE',
    scopes: [],
  },
  payInvoice: {
    actionId: 'PAY',
    resourceId: 'INVOICE',
    scopes: [],
  },
  payAndCreateReceipt: {
    actionId: 'PAY_AND_CREATE_RECEIPT',
    resourceId: 'INVOICE',
    scopes: [],
  },
  createCorrectiveTaxDocumentInvoice: {
    actionId: 'CREATE_CORRECTIVE_TAX_DOCUMENT',
    resourceId: 'INVOICE',
    scopes: [],
  },
  createMarginInvoiceItem: {
    actionId: 'CREATE_MARGIN_ITEM',
    resourceId: 'INVOICE',
    scopes: [],
  },
  renderMarginInvoicePrint: {
    actionId: 'RENDER_MARGIN_PRINT',
    resourceId: 'INVOICE',
    scopes: [],
  },
  renderInternalInvoiceDocument: {
    actionId: 'RENDER_INTERNAL_INVOICE_DOCUMENT',
    resourceId: 'INVOICE',
    scopes: [],
  },
  readMarginInvoiceSettings: {
    actionId: 'READ',
    resourceId: 'MARGIN_INVOICE_SETTINGS',
    scopes: [],
  },
  createMarginInvoiceSettings: {
    actionId: 'CREATE',
    resourceId: 'MARGIN_INVOICE_SETTINGS',
    scopes: [],
  },
  updateMarginInvoiceSettings: {
    actionId: 'UPDATE',
    resourceId: 'MARGIN_INVOICE_SETTINGS',
    scopes: [],
  },
  deleteMarginInvoiceSettings: {
    actionId: 'DELETE',
    resourceId: 'MARGIN_INVOICE_SETTINGS',
    scopes: [],
  },
  readPreAccountingProcessing: {
    actionId: 'READ',
    resourceId: 'PRE_ACCOUNTING_PROCESSING',
    scopes: [],
  },
  createPreAccountingProcessing: {
    actionId: 'CREATE',
    resourceId: 'PRE_ACCOUNTING_PROCESSING',
    scopes: [],
  },
  updatePreAccountingProcessing: {
    actionId: 'UPDATE',
    resourceId: 'PRE_ACCOUNTING_PROCESSING',
    scopes: [],
  },
  deletePreAccountingProcessing: {
    actionId: 'DELETE',
    resourceId: 'PRE_ACCOUNTING_PROCESSING',
    scopes: [],
  },
  readNegativeDocumentCancellationDefinition: {
    actionId: 'READ',
    resourceId: 'NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION',
    scopes: [],
  },
  createNegativeDocumentCancellationDefinition: {
    actionId: 'CREATE',
    resourceId: 'NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION',
    scopes: [],
  },
  updateNegativeDocumentCancellationDefinition: {
    actionId: 'UPDATE',
    resourceId: 'NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION',
    scopes: [],
  },
  deleteNegativeDocumentCancellationDefinition: {
    actionId: 'DELETE',
    resourceId: 'NEGATIVE_DOCUMENT_CANCELLATION_DEFINITION',
    scopes: [],
  },
  readQrCode: {
    actionId: 'READ',
    resourceId: 'QR_CODE_SETTINGS',
    scopes: [],
  },
  createQrCode: {
    actionId: 'CREATE',
    resourceId: 'QR_CODE_SETTINGS',
    scopes: [],
  },
  updateQrCode: {
    actionId: 'UPDATE',
    resourceId: 'QR_CODE_SETTINGS',
    scopes: [],
  },
  deleteQrCode: {
    actionId: 'DELETE',
    resourceId: 'QR_CODE_SETTINGS',
    scopes: [],
  },
  readRoundingDefinition: {
    actionId: 'READ',
    resourceId: 'ROUNDING_DEFINITION',
    scopes: [],
  },
  createRoundingDefinition: {
    actionId: 'CREATE',
    resourceId: 'ROUNDING_DEFINITION',
    scopes: [],
  },
  updateRoundingDefinition: {
    actionId: 'UPDATE',
    resourceId: 'ROUNDING_DEFINITION',
    scopes: [],
  },
  deleteRoundingDefinition: {
    actionId: 'DELETE',
    resourceId: 'ROUNDING_DEFINITION',
    scopes: [],
  },
  readTaxDocumentForPaymentSettings: {
    actionId: 'READ',
    resourceId: 'TAX_DOCUMENT_FOR_PAYMENT',
    scopes: [],
  },
  createTaxDocumentForPaymentSettings: {
    actionId: 'CREATE',
    resourceId: 'TAX_DOCUMENT_FOR_PAYMENT',
    scopes: [],
  },
  readVatCalculationDefinition: {
    actionId: 'READ',
    resourceId: 'VAT_CALCULATION_DEFINITION',
    scopes: [],
  },
  createVatCalculationDefinition: {
    actionId: 'CREATE',
    resourceId: 'VAT_CALCULATION_DEFINITION',
    scopes: [],
  },
  readVatCheckTotalsDefinition: {
    actionId: 'READ',
    resourceId: 'VAT_CHECK_TOTALS_DEFINITION',
    scopes: [],
  },
  createVatCheckTotalsDefinition: {
    actionId: 'CREATE',
    resourceId: 'VAT_CHECK_TOTALS_DEFINITION',
    scopes: [],
  },
  readAccountingTemplate: {
    actionId: 'READ',
    resourceId: 'TEMPLATE_ACCOUNTING',
    scopes: [],
  },
  readCashRegisterDocumentTemplate: {
    actionId: 'READ',
    resourceId: 'TEMPLATE_CASH_REGISTER_DOCUMENT',
    scopes: [],
  },
  createCheckoutDocuments: {
    actionId: 'CREATE_DOCUMENTS',
    resourceId: 'CHECKOUT',
    scopes: [],
  },
  createExternalCheckoutDocuments: {
    actionId: 'CREATE_EXTERNAL_DOCUMENTS',
    resourceId: 'CHECKOUT',
    scopes: [],
  },
} satisfies PermissionsRecordType;

export const ACCOUNTING_DOCUMENT_READ_PERMISSIONS = [
  accountingPermissions.readInvoice,
  accountingPermissions.readCashRegisterDocument,
];
